import React, {Component} from 'react';
import '../styles/channel/ChannelPurchaseNote.css'
import {Mask} from 'react-weui';

class PurchaseNotesModal extends Component {
    clickTheContent(e){
        e.stopPropagation()
    }
    render() {
         return  (
            <div>
                <Mask onClick={this.props.ClosePurchaseNotesModal}/>
                <div className="PurchaseNotesModal" onClick={this.props.ClosePurchaseNotesModal}>
                    <div className="PurchaseNotesModal_textArea" onClick={(e) => this.clickTheContent(e)}>
                        <div className="PurchaseNotesModal_title">
                            <p>购买须知</p>
                            <img onClick={this.props.ClosePurchaseNotesModal} src="https://static-cos.lycheer.net/picture/8173011_2a1f04155e8cd281977ca14c1659482b.jpg" alt=""/>
                        </div>
                        <div className="PurchaseNotesModal_main">
                            <p><span className="noTextUnderLine">尊敬的荔课平台用户，请您购买课程服务前，务必谨慎阅读以下条款：<br/>
                                1、【服务提示】深圳十方融海科技有限公司（以下称“荔课平台服务提供者”）系提供信息存储空间的网络服务提供者，除另行协商签订付费协议外，仅为您提供免费的荔课平台服务。
                                <br/> 2、【交易主体】请您了解，您在荔课平台购买的课程均系由课程页面上标示的用户为您提供，我司并非课程内容的提供者和销售者。请您明白，您一旦支付费用购买我司平台上其他用户提供的相关课程服务，即与提供课程服务的用户建立课程服务合同关系，我司不构成该服务合同关系的任一方。
                                <br/>3、【课程服务不适用七日无理由退货】请您知悉，荔课平台上提供的课程为在线收听的数字化商品，根据《消费者权益保护法》等规定，不适用七日无理由退货规定（您与课程提供者达成退款意向的除外），请您于购买时谨慎考虑。
                                <br/>4、【荔课平台支持退款的特殊情形】请您注意，荔课平台将在以下情况下协助您与课程提供者协商退款事宜：
                                <br/>4.1您申请退款时，该课程（包括专栏、单课）尚未开课的，您将于课程开课后获得退款；
                                <br/>4.2您购买的是已开课的专栏课程，且同时满足以下条件，课程提供者未拒绝退款的，您将于申请之日起7日获得退款：
                                <br/>（1）您于购买之日起7日内发起退款申请； <br/>（2）您购买后未收听课程的。
                                <br/>5、【退款金额】您的退款申请符合上述第4条的退款情形的，您支付的款项将原路全额退回您的账户，但若因退款产生第三方支付平台手续费的，将在扣除该手续费后退回剩余款项。</span>
                                <br/><span style={{textDecoration: 'none'}}>若您对以上条款有疑问，敬请您联系荔课平台客服。</span>
                                <span style={{
                                    textAlign: 'right',
                                    display: 'block',
                                    marginTop: 15,
                                    textDecoration: 'none'
                                }}>
                                    荔课平台服务提供者<br/>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PurchaseNotesModal



// WEBPACK FOOTER //
// ./src/components/PurchaseNotesModal.js